<template>
  <div>
    <h1>Liste des véhicules</h1>

    <va-card >
    
      <div class="row align--center">
        <div class="flex xs12 md6">
          <va-input
            :value="term"
            :placeholder="$t('tables.searchByName')"
            @input="search"
            removable
          >
            <va-icon name="fa fa-search" slot="prepend" />
          </va-input>
        </div>

        <div class="flex xs12 md3 offset--md3">
          <va-select
            v-model="perPage"
            :label="$t('tables.perPage')"
            :options="perPageOptions"
            noClear
          />
        </div>
      </div>
      
      
      <va-data-table
        :fields="fields"
        :data="filteredData"
        :per-page="parseInt(perPage)"
      >

       <template slot="actions" slot-scope="props">
        <va-popover placement="top"  title="Detail">
          <va-button @click="showCarDetail(props.rowData)" flat small color="gray" icon="fa fa-eye" />
        </va-popover>


      </template>

      </va-data-table>
  </va-card>

    <!-- modal showcar -->

      <va-modal size="large" v-model="showCarModal" title="Véhicule">

        <div class="row" v-if="carInfo">

          <div class="flex xs6">

            <div class="item">
              <h6>Photo véhicule</h6>
              <p><img :src="carInfo.car_picture" alt="" id="profil"></p>
            </div>

            <div class="item">
              <h6>Carte de voiture </h6>
              <p><a class="zoom" :href="carInfo.car_card" target="_blank"><img :src="carInfo.car_card" alt=""></a></p>
            </div>

            <div class="item">
              <h6>Visite technique</h6>
              <p><a class="zoom" :href="carInfo.driver.default_car.technical_review_card" target="_blank"><img :src="carInfo.driver.default_car.technical_review_card" alt=""></a></p>
            </div>

            <div class="item">
              <h6>Carte d'assurance</h6>
              <p><a class="zoom" :href="carInfo.driver.default_car.insurance_card" target="_blank"><img :src="carInfo.driver.default_car.insurance_card" alt=""></a></p>
            </div>

          </div>

          
          <div class="flex xs6">

            <div class="item" v-if="carInfo.driver">
              <h6 for="">Proprietaire du véhicule</h6>
              <p>
                 {{carInfo.driver.full_name}}
              </p> 
            </div>

            <div class="item" v-if="carInfo.driver">
              <h6 for="">Genre</h6>
              <p>
                 {{carInfo.driver.gender}}
              </p> 
            </div>

            <div class="item" v-if="carInfo.driver">
              <h6 for="">Téléphone</h6>
              <p>
                 {{carInfo.driver.phone}}
              </p> 
            </div>

            <div class="item" v-if="carInfo.driver">
              <h6 for="">Pays</h6>
              <p>
                 {{carInfo.driver.city}}
              </p> 
            </div>

            <div class="item" v-if="carInfo.driver">
              <h6 for="">Ville</h6>
              <p>
                 {{carInfo.driver.country}}
              </p> 
            </div>

            <div class="item">
              <h6 for="">Marque du véhicule</h6>
              <p>
                 {{carInfo.mark}}
              </p> 
            </div>

            <div class="item">
              <h6 for="">Model du véhicule</h6>
              <p>
                 {{carInfo.model}}
              </p> 
            </div>

            <div class="item">
              <h6 for="">Aire conditionné</h6>
              <p>
                 {{carInfo.air_conditioner}}
              </p> 
            </div>

            <div class="item">
              <h6 for="">Couleur du véhicule</h6>
              <p>
                 {{carInfo.color}}
              </p> 
            </div>

            <div class="item">
              <h6 for="">Matricule du véhicule</h6>
              <p>
                 {{carInfo.id_matricule}}
              </p> 
            </div>

          
          </div>
        </div>
      </va-modal> 

  </div>

</template>

<script>
import { debounce } from 'lodash'
import service from "../providers/service";

export default {
  data () {
    return {
      showCarModal: false,
      cars : [],
      carInfo: null,
      term: null,
      data : [],
      perPage: '6',
      perPageOptions: ['4', '6', '10']
    }
  },
  computed: {
    fields () {
      return [
         {
          name: 'driver.full_name',
          title: 'Nom complet',
          sortField: 'driver.full_name'
        },
        {
          name: 'mark',
          title: 'Marque ',
          sortField: 'mark'
        },
        {
          name: 'model',
          title: 'Model',
          sortField: 'model'
        },  
        {
          name: 'id_matricule',
          title: 'Matricule',
          sortField: 'id_matricule'
        }, 
        {
          name: '__slot:actions',
          dataClass: 'text-right',
        }
      ]
    },
     filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.data
      }

      return this.data.filter(item => {
        return item.driver.full_name.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
  },
  methods: {
     search: debounce(function (term) {
      this.term = term
    }, 400),

    showCarDetail(cars){
      this.carInfo = cars;
      console.log(cars);
      this.showCarModal = true;
    },

    edit (item) {
      alert('Edit User: ' + JSON.stringify(item))
    },

    remove (item) {

    },

    getListCars(){

      service.getCars(localStorage.userAccesstoken).then( res => {
          
        if(res.status === 200){
          this.data = res.data;
        }
  
      })
    }

  },
  mounted(){
    this.getListCars();
  }
}
</script>

<style lang="scss">
  img{
    width: 50%;
  }

  .item{
    margin: 1em;
    background-color: #e4e7f5;
    padding: 1em;
  }

  .zoom{
    cursor:zoom-in;
  }

</style>